import { useEffect } from "react";
import { useMap } from "react-map-gl/mapbox";

/**
 * Sets cursor to pointer when hovering over a layer.
 * Automatically resets cursor when mouse leaves the layer.
 */
export function useCursorOnHover(layerId: string, enabled = true): void {
  const { current: map } = useMap();

  useEffect(() => {
    if (!map || !enabled) return;

    const handleEnter = () => {
      map.getCanvas().style.cursor = "pointer";
    };

    const handleLeave = () => {
      map.getCanvas().style.cursor = "";
    };

    map.on("mouseenter", layerId, handleEnter);
    map.on("mouseleave", layerId, handleLeave);

    return () => {
      map.off("mouseenter", layerId, handleEnter);
      map.off("mouseleave", layerId, handleLeave);
    };
  }, [map, layerId, enabled]);
}
